import axios from "../api";

export const createTripolaPlanAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/tripola-plans/create", data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const updateTripolaPlanAction = async (id, data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/tripola-plans/${id}`, data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const getTripolaPlanByIdAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/tripola-plans/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const listAllTripolaPlansAction = (
  page,
  pageSize,
  searchValue = "",
  is_active = "",
  is_deleted = ""
) => {
  let apiUrl = `/api/tripola-plans?page=${page}&pageSize=${pageSize}`;

  if (searchValue) {
    apiUrl += `&searchValue=${encodeURIComponent(searchValue)}`;
  }

  if (is_active !== "" && is_active !== null) {
    apiUrl += `&is_active=${is_active}`;
  }

  if (is_deleted !== "" && is_deleted !== null) {
    apiUrl += `&is_deleted=${is_deleted}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const deleteTripolaPlansAction = async (ids, deleteType = "soft") => {
  return new Promise((resolve, reject) => {
    axios
      .delete("/api/tripola-plans/delete", {
        data: {
          ids: Array.isArray(ids) ? ids : [ids],
          deleteType,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};


export const updateTripolaPlanStatusAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(`/api/tripola-plans/toggle/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const listTripolaPlansForDropdownAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/tripola-plans/plan-dropdown")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};


export const listTripolaTransactionDataAction = async (perPage, page, searchValue, startDate, endDate, statusFilter, amountFilter, tenantFilter) => {
  let apiUrl = `/api/tripola-plans/tripolatransaction?page=${page}&pageSize=${perPage}&status=${statusFilter}`;

  if (amountFilter) {
    apiUrl += `&amount=${amountFilter}`;
  }

  if (searchValue !== "all") {
    searchValue = searchValue.trim();
    apiUrl += `&search=${searchValue}`;
  }

  if (startDate && endDate) {
    apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
  }

  if (tenantFilter !== "all") {
    apiUrl += `&tenantId=${tenantFilter}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTripolaTenantsAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get('/api/tripola-plans/tripolatenants') // Adjust the endpoint based on your route
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};



export const exportTripolaTransactionHistoryAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/tripola-plans/tripolatransactions/export', data, {
        responseType: 'blob'
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};